<div class="flex flex-col" [class.thin-show-text]="isInvisibleSelected">
  @if (requirement?.is_monitored) {
    <div class="absolute pr-2.5 border-r border-navy-40 right-40 z-10 flex mt-1 h-4.5">
      <svg-icon
        class="mt-0.5"
        [class.not-displaying-monitoring]="!showMonitoredIndication"
        [src]="'monitored'"
      ></svg-icon>
    </div>
  }

  <div class="requirement-actions">
    <app-icon-button
      class="reset-btn"
      [type]="'basic'"
      [size]="'micro'"
      [verticalSize]="'micro'"
      [svgIconPath]="'refresh'"
      [iconSize]="'tiny'"
      [ngbTooltip]="buildTranslationKey('resetNameToDefault') | translate"
      [placement]="'top'"
      (click)="resetRequirementName()"
    ></app-icon-button>

    <app-icon-button
      class="navigate-btn"
      [type]="'basic'"
      [size]="'micro'"
      [verticalSize]="'micro'"
      [svgIconPath]="'newscreen'"
      [iconSize]="'tiny'"
      [ngbTooltip]="buildTranslationKey('viewRequirement') | translate"
      [placement]="'top'"
      (click)="navigateToRequirement()"
    ></app-icon-button>
  </div>

  <dynamic-form-outlet [dynamicFormGroup]="form"></dynamic-form-outlet>

  @if (frameworks.length) {
    <div class="linked-frameworks flex flex-col gap-y-1.5 mt-5" [class.opacity-50]="!displayLinkedFrameworks">
      <div class="flex gap-x-1">
        <svg-icon class="linked-icon w-4.5 h-4.5" [src]="'linked'"></svg-icon>

        <span class="font-main font-bold text-navy-90 text-base">
          {{
            linkedFrameworksTranslationKey
              | translate: { numberOfControls: controls.length, numberOfFrameworks: frameworks.length }
          }}
        </span>
      </div>

      <div class="flex gap-2 flex-wrap">
        @for (framework of frameworks; track $index) {
          <app-label
            [isHoverable]="false"
            [type]="'transparent'"
            [name]="framework"
            [ngbTooltip]="getFrameworkControls(framework)?.length ? linkedControlsTemplate : null"
            [placement]="'top'"
          ></app-label>

          <ng-template #linkedControlsTemplate>
            <div *ngVar="getFrameworkControls(framework) as controls" class="flex flex-col">
              <span class="font-bold mb-3">
                {{ buildTranslationKey('controlSummary.linkedTo') | translate }}
                {{ controls.length | i18nPlural: controlLabelMapping | translate: { numberOfControls: controls.length } }}:
              </span>

              <div class="flex flex-col gap-2 pl-2.5">
                @for (control of controls; track $index) {
                  <span>{{ control }}</span>
                }
              </div>
            </div>
          </ng-template>
        }
      </div>
    </div>
  }
</div>
